import styled from 'styled-components'
import { Button } from 'antd'
import { UserOutlined, LogoutOutlined } from '@ant-design/icons'
import { getAuth, signOut } from 'firebase/auth'
import logo from '../assets/sercacador_branco.png'
import { useNavigate } from 'react-location'

const Navbar = ({
  changedNavigation,
}: {
  changedNavigation: (e: string) => void
}) => {
  const navigate = useNavigate()

  const handleNavigationClick = (key: string) => {
    if (key === 'exit') {
      const auth = getAuth()
      signOut(auth)
        .then(() => {
          // Sign-out successful.
          navigate({ to: '/', replace: true })
        })
        .catch((error) => {
          // An error happened.
          console.log('error', error)
        })
    }

    changedNavigation(key)
  }

  return (
    <Container>
      <Logo />
      <Navigation>
        <Button
          style={{ marginRight: '10px' }}
          type="primary"
          icon={<UserOutlined />}
          onClick={() => handleNavigationClick('profile')}
        >
          Minha Conta
        </Button>
        <Button
          type="primary"
          icon={<LogoutOutlined />}
          onClick={() => handleNavigationClick('exit')}
        >
          Sair
        </Button>
      </Navigation>
    </Container>
  )
}

/*
{JSON.parse(
            window.sessionStorage.getItem(FirebaseSessionKey) as string
          )?.displayName || ''}
*/

export default Navbar

const Container = styled.div`
  display: flex;
  height: 100px;
  max-height: 100px;
  min-height: 100px;
  background-color: #1d263a;
  padding: 10px;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
`

const Logo = styled.div`
  background: url(${logo});
  width: 150px;
  height: 100px;
  max-height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-top: 5px;
`

const Navigation = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`
